import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import ComercialDropDown from './inputs/ComercialDropDown';
import ComercialDropDown from './inputs/NewComercialDropDown';
import EstadoOfertaDropdown from './inputs/EstadoOfertaDropdown';
import PotencialClienteDropdown from './inputs/PotencialClienteDropdown';
import ClienteDropdown from './inputs/ClienteDropdown';
import TipoVisitaDropdown from './inputs/TipoVisitaDropdown';
import SegmentoDropdown from './inputs/SegmentoDropdown';
import Comentarios from './inputs/Comentarios';
import MapaUbicacion from './inputs/MapaUbicacion';
import { getApiUrl } from '../../utils/apiConfig';
import { usePermisos } from '../../context/PermisosContext';
import AdminReadOnlyAlert from '../AdminReadOnlyAlert';
import { ChevronLeft } from 'lucide-react';



import { CircleCheck, CircleX } from 'lucide-react';

const formatCurrency = (value) => {
  if (value === '' || value === null || value === undefined || isNaN(value)) return '';
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(value);

  return formatted.replace('€', '€ ');
};

const VisitaEditar = ({ visita, setVisita, onSave, onUpdateVisita, onClose, user, refreshVisitas, comercialIdsPermitidos}) => {
  const navigate = useNavigate();
  const { isAdmin } = usePermisos(); // 🔒 Obtener si es admin
  const [isEditing, setIsEditing] = useState(false);
  const [originalVisita, setOriginalVisita] = useState(null);
  const [successMsg, setSuccessMsg] = useState('');
  const [saving, setSaving] = useState(false);
  const [obraRelacionada, setObraRelacionada] = useState(null);
  const [loadingObra, setLoadingObra] = useState(false);
  // Nuevo cliente modal
  // const [nuevoClienteModalOpen, setNuevoClienteModalOpen] = useState(false);
  // const [nuevoClienteNombre, setNuevoClienteNombre] = useState('');
  // const [nuevoClienteError, setNuevoClienteError] = useState('');

  useEffect(() => {
    if (visita) {
      setOriginalVisita(JSON.stringify(visita));
      setSuccessMsg('');
      
      // Si la visita tiene IdObra, crear objeto obra desde los datos ya disponibles
      if (visita.IdObra) {
        // Si la vista ya incluye campos de obra, usarlos directamente
        // De lo contrario, hacer fetch solo si no están disponibles
        if (visita.ObraNombre || visita.ObraConstructora) {
          // Los datos ya están en visita, no necesitamos hacer fetch
          setObraRelacionada({
            IdObra: visita.IdObra,
            Obra: visita.ObraNombre,
            Constructora: visita.ObraConstructora,
            Comercial: visita.ObraComercial,
            EstadoObra: visita.ObraEstado,
            Subdivision: visita.ObraSubdivision,
            CalleObra: visita.ObraCalleObra,
            NumeroObra: visita.ObraNumeroObra,
            PoblacionObra: visita.ObraPoblacionObra,
          });
        } else {
          // Fallback: hacer fetch solo si los datos no están disponibles
          // setLoadingObra(true);
          // fetch(`http://localhost:5000/api/obras/${visita.IdObra}`)
          //   .then(res => res.json())
          //   .then(data => {
          //     setObraRelacionada(data);
          //     setLoadingObra(false);
          //   })
          //   .catch(err => {
          //     console.error('Error al cargar obra:', err);
          //     setLoadingObra(false);
          //   });
          setLoadingObra(true);
          fetch(`${getApiUrl('/api/obras')}/${visita.IdObra}/mini`)
            .then(res => res.json())
            .then(data => {
              setObraRelacionada(data);
              setLoadingObra(false);
            })
            .catch(err => {
              console.error('Error al cargar obra:', err);
              setLoadingObra(false);
            });

        }
      } else {
        setObraRelacionada(null);
      }
    }
  }, [visita?.IdOferta, visita?.IdObra]);

  const isModified = originalVisita !== JSON.stringify(visita);

  if (!visita) return null;

  // Validación de campos obligatorios
  const requiredFields = [
    'IdComercial',
    'IdCliente',
    'FechaVisita',
    'IdTipoVisita',
    'IdSegmento',
    'PotencialCliente',
    'EstadoOferta',
  ];
  const missing = requiredFields.filter(f => {
    const value = visita[f];
    // Considerar vacío si es null, undefined, string vacío, o 0 (excepto para campos numéricos válidos)
    return value === null || value === undefined || value === '' || (typeof value === 'string' && value.trim() === '');
  });
  const isFormValid = missing.length === 0;

  const handleSave = async () => {
    if (!isModified) return;
    
    // Validar campos obligatorios antes de guardar
    if (!isFormValid) {
      // console.log('Campos faltantes:', missing);
      // console.log('Visita actual:', visita);
      
      // Mapear nombres técnicos a nombres legibles
      const nombresLegibles = {
        'IdComercial': 'Comercial',
        'IdCliente': 'Cliente',
        'FechaVisita': 'Fecha de Visita',
        'IdTipoVisita': 'Tipo de Visita',
        'IdSegmento': 'Segmento',
        'PotencialCliente': 'Potencial Cliente',
        'EstadoOferta': 'Estado de Oferta',
      };
      
      const camposLegibles = missing.map(campo => nombresLegibles[campo] || campo);
      
      // Usar un separador especial para distinguir el título de la lista
      const listaCampos = camposLegibles.map(c => `• ${c}`).join('\n');
      
      setSuccessMsg(`TITULO||Faltan campos obligatorios:||LISTA||${listaCampos}`);
      setTimeout(() => setSuccessMsg(''), 5000);
      return;
    }
    
    setSaving(true);
    try {
      const updated = await onSave();
      setSuccessMsg('¡Visita modificada correctamente!');
      setSaving(false);
      setTimeout(async () => {
        if (updated && typeof onUpdateVisita === 'function') {
          onUpdateVisita(updated); // Actualiza la lista en el padre y cierra el modal
          await refreshVisitas();  
        } else {
          onClose();
        }
        setSuccessMsg('');
      }, 5000); // Tiempo que se muestra el mensaje Success
    } catch (err) {
      setSuccessMsg('Error al guardar los cambios');
      setSaving(false);
    }
  };

  return (
    <div className="p-4 sm:p-6 lg:p-6 bg-gray-50 min-h-screen no-select">
      <div className="max-w-7xl mx-auto">

      {/* Header */}
      {/* <div className="flex flex-col sm:flex-row gap-4 my-4 sm:gap-0 sm:justify-between sm:items-center">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">Visitas</h1>
          <p className="text-gray-600 mt-1 text-sm sm:text-base">Editar visita</p>
        </div>
        <div className="flex items-center gap-3 bg-white px-3 sm:px-4 py-2 sm:py-3 rounded-xl shadow-sm border hover:shadow-lg hover:border-blue-200 transition-all duration-300 cursor-pointer">
          <div className="w-7 h-7 sm:w-8 sm:h-8 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full flex items-center justify-center text-white font-semibold text-xs sm:text-sm">
            {user?.name?.charAt(0)?.toUpperCase() || 'U'}
          </div>
          <div className="text-right">
            <p className="font-medium text-gray-800 text-xs sm:text-sm md:text-base truncate max-w-[100px] sm:max-w-[150px] md:max-w-none">
              {user?.name || 'Usuario'}
            </p>
          </div>
        </div>
      </div> */}

      {/* Header */}
      <div className="flex flex-col sm:flex-row gap-4 my-4 sm:gap-0 sm:justify-between sm:items-center">
        <div className="flex items-center gap-6">
          {/* Botón volver */}
          <button
            onClick={onClose}
            className="flex items-center justify-center w-10 h-10 rounded-lg bg-white border border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-colors"
            title="Volver a Obras"
          >
            <ChevronLeft className="w-6 h-6 text-gray-600" />
          </button>
          
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">Visitas</h1>
            <p className="text-gray-600 text-sm sm:text-base">Editar visitas</p>
          </div>
        </div>
        
        <div className="flex items-center gap-3 bg-white px-3 sm:px-4 py-2 sm:py-3 rounded-xl shadow-sm border hover:shadow-lg hover:border-blue-200 transition-all duration-300 cursor-pointer">
          <div className="w-7 h-7 sm:w-8 sm:h-8 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full flex items-center justify-center text-white font-semibold text-xs sm:text-sm">
            {user?.name?.charAt(0)?.toUpperCase() || 'U'}
          </div>
          <div className="text-right">
            <p className="font-medium text-gray-800 text-xs sm:text-sm md:text-base truncate max-w-[100px] sm:max-w-[150px] md:max-w-none">
              {user?.name || 'Usuario'}
            </p>
          </div>
        </div>
      </div>


      <div className="w-full">

        {/* 🔒 Alerta para admins */}
        {isAdmin && <AdminReadOnlyAlert tipo="visita" />}

        <div className="flex flex-col gap-3 border rounded-lg bg-white p-4 shadow-sm p-4 sm:p-4 w-full mb-6">
          
          <p className="font-medium">Información Comercial</p>
          <hr className='mb-1'></hr>

          <div className="flex flex-col sm:flex-row gap-4 w-full">
          
            <div className="flex-1 min-w-0 sm:min-w-[180px]">
              <ComercialDropDown selectedVisita={visita} setSelectedVisita={setVisita} user={user} comercialIdsPermitidos={comercialIdsPermitidos}/>
            </div>

            <div className="flex-1 min-w-0 sm:min-w-[180px]">
              <label htmlFor="inputOferta" className="block mb-1 text-xs font-medium text-gray-700 truncate">
                Oferta
              </label>
              <input
                type="text"
                id="inputOferta"
                placeholder='Num Oferta'
                className="inputModal w-full shadow-sm p-2 border rounded bg-white truncate"
                value={visita.Oferta || ''}
                onChange={(e) => setVisita({ ...visita, Oferta: e.target.value })}
              />
            </div>

            <div className="flex-1 min-w-0 sm:min-w-[180px]">
              <label htmlFor="fechaVisita" className="block mb-1 text-xs font-medium text-gray-700 truncate">
                Fecha Visita*
              </label>
              <input
                type="date"
                id="fechaVisita"
                className="inputModal w-full p-2 shadow-sm border rounded bg-white truncate"
                value={visita.FechaVisita?.slice(0, 10) || ''}
                onChange={(e) => setVisita({ ...visita, FechaVisita: e.target.value })}
              />
            </div>
            
          </div>

          <div className="flex-1 min-w-[180px]">
            <label className="block mb-1 text-xs font-medium text-gray-700 truncate">Observaciones Comercial</label>
            <textarea className="truncate shadow-sm w-full p-2 border rounded bg-white mb-0 resize-y min-h-[60px] text-sm" value={visita.ObservacionesC || ''} onChange={e => setVisita({ ...visita, ObservacionesC: e.target.value })} />
          </div>

        </div>

        <div className="flex flex-col gap-3 border rounded-lg bg-white p-4 shadow-sm p-4 sm:p-4 w-full mb-6">

          <p className="font-medium">Información de la Visita</p>
          <hr className='mb-1'></hr>
          
          {/* Contenedor principal: formulario (izquierda) + mapa (derecha) */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            
            {/* Formulario ocupa 2 columnas */}
            <div className="lg:col-span-2 flex flex-col gap-4">
              
              {/* Fila 1 */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <EstadoOfertaDropdown selectedVisita={visita} setSelectedVisita={setVisita} />
                <PotencialClienteDropdown selectedVisita={visita} setSelectedVisita={setVisita} />
              </div>

              {/* Fila 2 */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex gap-2 items-center">
                  <ClienteDropdown selectedVisita={visita} setSelectedVisita={setVisita} />
                </div>
              </div>
              
              {/* Fila 3 */}
              <div className="flex flex-col md:flex-row gap-3">
                <div className="w-full md:w-32">
                  <label className="block mb-1 text-xs font-medium text-gray-700 truncate">Número</label>
                  <input
                    type="text"
                    inputMode="text"
                    maxLength={6}
                    minLength={1}
                    className="inputModal shadow-sm w-full p-2 border rounded bg-white mb-0 truncate"
                    value={visita.NumeroDireccionInput !== undefined ? visita.NumeroDireccionInput : (visita.NumeroDireccion || '')}
                    onChange={e => {
                      const value = e.target.value;
                      setVisita(prev => ({
                        ...prev,
                        NumeroDireccionInput: value,
                        NumeroDireccion: value
                      }));
                    }}
                  />
                </div>
                
                <div className='flex-1 min-w-[180px]'>
                  <label className="block mb-1 text-xs font-medium text-gray-700 truncate">
                    Ubicación / Dirección
                  </label>
                  <input
                    type="text"
                    placeholder="Ej: Calle Mayor 123, Madrid"
                    className="inputModal w-full shadow-sm p-2 border rounded bg-white truncate"
                    value={visita.Direccion || ''}
                    onChange={(e) => setVisita({ ...visita, Direccion: e.target.value })}
                  />
                </div>
              </div>

              {/* Fila 4 */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div>
                  <label className="block mb-1 text-xs font-medium text-gray-700 truncate">Importe aproximado oferta</label>
                  <input
                    type="text"
                    placeholder='€ 0,00'
                    className={`inputModal w-full p-2 border shadow-sm rounded bg-white truncate ${
                      visita?.ImporteAproxOferta !== '' && visita?.ImporteAproxOferta != null && Number(visita?.ImporteAproxOferta) > 0
                        ? 'font-semibold text-green-600'
                        : ''
                    }`}
                    value={
                      isEditing
                        ? visita.ImporteAproxOferta ?? ''
                        : formatCurrency(visita.ImporteAproxOferta)
                    }
                    onFocus={() => setIsEditing(true)}
                    onBlur={() => setIsEditing(false)}
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/[^\d,]/g, '').replace(',', '.');
                      const numericValue = parseFloat(rawValue);
                      setVisita({
                        ...visita,
                        ImporteAproxOferta: isNaN(numericValue) ? '' : numericValue,
                      });
                    }}
                  />               
                </div>

                <TipoVisitaDropdown selectedVisita={visita} setSelectedVisita={setVisita} />
                <SegmentoDropdown selectedVisita={visita} setSelectedVisita={setVisita} />
              </div>

              {/* Comentarios (ancho completo dentro del formulario) */}
              <div className="w-full">
                <Comentarios selectedVisita={visita} setSelectedVisita={setVisita} />
              </div>

            </div>

            {/* Mapa ocupa 1 columna */}
            <div className="lg:col-span-1 h-full" style={{ minHeight: '500px' }}>
              <MapaUbicacion visita={visita} setVisita={setVisita} />
            </div>

          </div>

        </div>        <div className="flex mb-6 flex-col gap-3 border rounded-lg bg-white p-4 shadow-sm p-4 sm:p-4 w-full">
          <p className="font-medium">Seguimiento OBRA</p>
          <hr className='mb-1'></hr>
          
          {loadingObra ? (
            <div className="flex items-center justify-center py-4">
              <svg className="h-5 w-5 animate-spin text-purple-600" viewBox="0 0 24 24" fill="none">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
              </svg>
              <span className="ml-2 text-sm text-gray-600">Cargando información de la obra...</span>
            </div>
          ) : obraRelacionada ? (
            <div 
              className="border rounded-lg p-4 bg-white hover:bg-gray-50 cursor-pointer"
              onClick={() => {
                // Navegar a obras con el parámetro openObra para abrir automáticamente el modal
                navigate(`/dashboard/obras?openObra=${obraRelacionada.IdObra}`);
              }}
              title="Haz clic para abrir esta obra"
            >
              <div className="flex items-center justify-between mb-3">
                <h4 className="font-semibold text-blue-800 flex items-center gap-2">
                <div className="p-3 bg-purple-100 rounded-xl">
                  <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                  {obraRelacionada.Obra} - {obraRelacionada.IdObra}
                </h4>
                <span className="text-xs text-blue-600 font-medium">Ver detalles</span>
              </div>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
                <div>
                  <span className="text-gray-600">Constructora:</span>
                  <span className="ml-2 font-medium text-gray-800">{obraRelacionada.Constructora || '-'}</span>
                </div>
                <div>
                  <span className="text-gray-600">Comercial:</span>
                  <span className="ml-2 font-medium text-gray-800">{obraRelacionada.Comercial || '-'}</span>
                </div>
                <div>
                  <span className="text-gray-600">Estado:</span>
                  <span className="ml-2 px-2 py-0.5 bg-purple-100 text-purple-800 rounded text-xs font-medium">
                    {obraRelacionada.EstadoObra || '-'}
                  </span>
                </div>
                <div>
                  <span className="text-gray-600">Población:</span>
                  <span className="ml-2 px-2 py-0.5 bg-blue-100 text-blue-800 rounded text-xs font-medium">{obraRelacionada.Subdivision || '-'}</span>
                </div>
                <div className="sm:col-span-2">
                  <span className="text-gray-600">Dirección:</span>
                  <span className="ml-2 font-medium text-gray-800">
                    {obraRelacionada.NumeroDireccion} {obraRelacionada.Direccion}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center py-4 text-gray-500 text-sm">
              Esta visita no está relacionada con ninguna obra
            </div>
          )}
        </div>

        {/* Botones de acción (estilo minimal) */}
        <div className="flex justify-end mt-2 gap-2 sm:gap-2 pt-3 mb-5 md:mb-0">
          <button
            type="button"
            onClick={onClose}
            className="px-3 py-1.5 rounded-lg text-red-600 border bg-red-50 hover:bg-red-100 border-red-200 text-sm font-medium transition-colors"
            title="Cerrar sin guardar"
          >
            Cancelar
          </button>

          {(() => {
            const canSave = isModified && isFormValid && !saving && !successMsg && !isAdmin; // 🔒 Deshabilitar para admins
            const disabledReason = isAdmin
              ? 'Los administradores no pueden editar visitas'
              : !isModified
              ? 'No hay cambios para guardar'
              : !isFormValid
              ? `Faltan campos obligatorios: ${missing.join(', ')}`
              : successMsg
              ? 'La operación ya se completó'
              : saving
              ? 'Guardando…'
              : '';
            return (
              <button
                type="button"
                onClick={handleSave}
                disabled={!canSave}
                aria-busy={saving || undefined}
                title={!canSave ? disabledReason : 'Guardar cambios'}
                className={`px-3 py-1.5 rounded-lg text-blue-600 border bg-blue-50 hover:bg-blue-100 border-blue-200 text-sm font-medium transition-colors ${
                  canSave
                    ? 'hover:bg-blue-100 border-blue-200'
                    : 'bg-white text-gray-400 border-gray-200 cursor-not-allowed'
                }`}
              >
                {saving ? (
                  <>
                    <svg className="h-3 w-3 inline-block mr-2 animate-spin align-[-2px]" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                    </svg>
                    Guardando…
                  </>
                ) : (
                  'Guardar'
                )}
              </button>
            );
          })()}
        </div>

        {/* Overlay de Success/Error */}
        {successMsg && (

          
          <div 
            className="fixed inset-0 z-[1500] flex items-center justify-center cursor-pointer"
            onClick={() => setSuccessMsg('')}
            title="Haz clic para cerrar"
          >
            <div className="bg-gray-600 rounded-2xl px-6 py-5 shadow-2xl w-auto max-w-md">
              <div className="flex flex-col items-center text-center gap-3">
                {successMsg.startsWith('¡') ? (
                  <CircleCheck className="w-20 h-20 text-green-500" aria-hidden="true" />
                ) : (
                  <CircleX className="w-20 h-20 text-red-500" aria-hidden="true" />
                )}

                {successMsg.includes('TITULO||') ? (
                  <div role="alert" aria-live="polite" className="text-white px-2 text-left w-full">
                    {(() => {
                      const parts = successMsg.split('||');
                      const titulo = parts[1] || '';
                      const lista = parts[3] || '';
                      return (
                        <>
                          <p className="text-base font-medium mb-2">{titulo}</p>
                          <p className="text-sm whitespace-pre-line">{lista}</p>
                        </>
                      );
                    })()}
                  </div>
                ) : (
                  <p role="alert" aria-live="polite" className="text-white text-base font-medium px-2 whitespace-pre-line text-left">
                    {successMsg}
                  </p>
                )}
                
                {!successMsg.startsWith('¡') && (
                  <p className="text-gray-300 text-xs mt-1">
                    Haz clic para cerrar
                  </p>
                )}
              </div>
            </div>
          </div>
        )}


      </div>
        
      </div>
    </div>
  );
}

export default VisitaEditar;
